module.exports = __webpack_public_path__ + "img/popular1.70032373.jpg";